import { create } from "zustand";
// import { signal } from "@preact/signals-react";

import { useStore } from "storev2/formStore";
import { getViewFields, recToTryton } from "componentsv2/tools/functions";
import proxy from "api/proxy";

// Example Map for store
// Case for Board staff.access
// store = Map({
//   "staff.access": {
//     records: Array,
//     create: new Map(),
//     write: new Map(),
//     delete: Array,
//     selected: new Map(),
//   },
// });
// Case for split sale in another sale moving sale lines (in sale POS)
// store = Map({
//   "sale.sale,2": {
//     model: 'sale.line',
//     records: Array,
//     create: new Map(),
//     write: new Map(),
//     delete: Array,
//     selected: new Map(),
//   },
//   "sale.sale,3": {
//     model: 'sale.line',
//     records: Array,
//     create: new Map(),
//     write: new Map(),
//     delete: Array,
//     selected: new Map(),
//   },
// };

function updateDomain(table, domain) {
  // if (!domain) return;
  // const domainCtx = table.domain;
  // domainCtx.push(domain);
}

function buildDomain(domainCtx) {
  let activeDomain = null;
  for (const [_, dom] of Object.entries(domainCtx)) {
    if (dom) {
      if (!activeDomain) {
        activeDomain = [];
      }
      if (dom.length === 0) continue;
      activeDomain.push(dom);
    }
  }
  return activeDomain;
}

function updateRowData(data, record) {
  const action = record.id > 0 ? "write" : "create";
  const rows = data.get(action);
  const rowsMap = rows.set(record.id, recToTryton(record));
  data.set(action, rowsMap);
}

function defaultDomain(layout, parent) {
  let strictDom = layout?.domain || null;
  if (parent?.target && parent?.record?.id) {
    strictDom = [`${parent.target}`, "=", parent?.record?.id];
  }

  return {
    default: layout.softDomain || null,
    strict: strictDom,
    search: null,
    date: null,
    filter: null,
    fields: null,
  };
}

async function fetchData(layout, dom, returnType, offset = 0) {
  const domain = dom ?? [];
  const limit = layout.limit ?? 200;
  const fields = getViewFields(layout, "list");
  const orderBy = layout.orderBy;
  const { data } = await proxy.search(
    layout.model,
    domain,
    fields,
    limit,
    orderBy,
    offset,
  );
  let _data = data;
  if (returnType === "Map") {
    _data = new Map();
    data.forEach((rec) => _data.set(rec.id, rec));
  }
  return _data;
}

async function fetchCount(layout, dom) {
  const domain = dom ?? [];
  const model = layout.model;
  const { data } = await proxy.searchCount(model, domain);
  return data ?? 0;
}
async function deleteRecord(model, id) {
  return await proxy.remove({
    model: model,
    ids: [id],
  });
}

const useTable = create((set, get) => ({
  // store: new Map(),
  // name: (model, id) => {
  //   return id ? `${model},${id}` : model;
  // },
  // records: signal(new Map()),
  // domains: new Map(),
  getDomain: (layout, ctx, storeId, domain, reset = false) => {
    // ctx => date, search, filter, fields
    // const { domains } = get();
    const data = get();
    const tableStore = data[storeId];

    const dom = domain ?? defaultDomain(layout);
    if (reset) {
      dom.strict = null;
    }

    dom.default = null;
    dom[ctx] = domain;
    // domains.set(key, dom);
    // set(() => ({
    //   domains: new Map(domains),
    // }));
    return buildDomain(dom);
  },
  getDomainX: (layout, parent) => {
    const { domains } = get();

    let domain = domains.get(key);
    if (!domain) {
      domain = defaultDomain(layout, parent);
    }
    let activeDomain = null;
    for (const [ctx, dom] of Object.entries(domain)) {
      if (dom) {
        if (!activeDomain) {
          activeDomain = [];
        }
        if (dom.length === 0) continue;
        activeDomain.push(dom);
      }
    }

    if (!activeDomain) return null;
    return activeDomain;
  },
  getTable: (storeId) => {
    // Return a table stored in the store
    const data = get();
    return data[storeId];
  },
  setTable: async ({
    storeId,
    layout,
    domain,
    records,
    parent,
    modelChild,
  }) => {
    // key is a string =>  model|domain ? Deprecation
    // const { getDomain } = get();
    let domain_ = domain ?? defaultDomain(layout);
    let records_ = records || [];
    // if (parent) {
    //   records_ = records || signal[];
    // } else
    // let records_;
    // if (records.value.size > 0) {
    //   records_ = records.value;
    // } else {
    //   records_ = signal(new Map());
    // }
    // let _records = records.value.size > 0 || ;
    // if (!records && !domain) {
    //   domain_ = getDomain(layout, key, parent);
    // }
    let count_ = 0;
    let queried_ = false;
    if (domain_) {
      records_ = await fetchData(layout, domain_);
      count_ = await fetchCount(layout, domain_);
      queried_ = true;
      console.log("Encontre los records....", records_);
    }
    const table = {
      storeId: storeId,
      layout: layout,
      records: records_,
      domain: domain_,
      offset: 0,
      count: count_,
      queried: queried_,
      create: new Map(),
      write: new Map(),
      delete: [],
      selected: new Map(),
      parent: parent,
    };
    if (modelChild) {
      table.model = modelChild;
    }
    const newStoreTable = {};
    newStoreTable[storeId] = table;
    // console.log("newStoreTable > ", newStoreTable);
    set((state) => ({ ...state, ...newStoreTable }));
    return table;
  },
  findRecords: async (table, newDomain) => {
    let fullDomain = table.domain;
    if (newDomain) {
      fullDomain = { ...table.domain, ...newDomain };
      delete fullDomain.offset;
    }
    const offset = newDomain?.offset ?? table.offset ?? 0;
    const domain = buildDomain(fullDomain);
    let records = [];
    if (domain) {
      records = await fetchData(table.layout, domain, null, offset);
    }
    return records;
  },
  markSelected: (key, checkAll) => {
    const table = get().getTable(key);
    if (!table || !table.layout.selectable) return;
    const selected = new Map();
    if (table.layout.selectable === "multi") {
      if (checkAll) {
        table.records.forEach((record) => {
          selected.set(record.id, record);
        });
      }
    }
    table.selected = selected;
    set({ [key]: table });
  },
  handleSelected: (storeId, rec) => {
    const data = get();

    const table = data[storeId];

    if (!table || !table.layout.selectable) return;
    let selected = table.selected;
    if (table.layout.selectable === "multi") {
      if (selected.get(rec.id)) {
        selected.delete(rec.id);
      } else {
        selected.set(rec.id, rec);
      }
    } else {
      selected = new Map([[rec.id, rec]]);
    }
    table.selected = new Map(selected);
    const newStoreTable = {};
    newStoreTable[storeId] = table;

    set(newStoreTable);
  },
  resetSelected: (key) => {
    const table = get().getTable(key);
    if (!table) return;

    table.selected = new Map();
    set({ [key]: table });
  },
  updateTable: async (table, records) => {
    table.records = records;
    const newStoreTable = {};
    newStoreTable[table.storeId] = table;
    set((state) => ({ ...state, ...newStoreTable }));
  },
  reload: async (storeId, domain) => {
    const { getTable, findRecords, updateTable } = get();

    const table = getTable(storeId);

    if (!table) {
      return;
    }

    if (domain) {
      const { offset, ...rest } = domain;
      table.domain = { ...table.domain, ...rest };
      if (offset !== undefined) {
        table.offset = offset;
      }
    }

    let combinedDomain = table.domain;
    if (domain?.search && table.layout?.domain) {
      combinedDomain = {
        ...table.domain,
        search: ["AND", table.layout.domain, domain.search],
      };
    }
    console.log("ues table reloading...", table, combinedDomain);
    const records = await findRecords(table, combinedDomain);

    let countCtx = table.domain;
    if (combinedDomain) {
      countCtx = { ...table.domain, ...combinedDomain };
    }
    delete countCtx.offset;
    const builtDomain = buildDomain(countCtx);
    table.count = await fetchCount(table.layout, builtDomain);
    table.queried = true;
    table.selected = new Map();

    updateTable(table, records);
  },
  resetTable: (key) => {
    const { store, name } = get();
    const res = store.delete(key);
    if (!res) return;
    set((state) => ({
      store: new Map([...state.store, ...store]),
    }));
  },
  resetRecords: (key) => {
    set((state) => ({
      records: [],
    }));
  },
  resetDomains: () => {
    set(() => ({
      domains: new Map(),
    }));
  },
  updateRow: (storeId, record) => {
    const table = get().getTable(storeId);
    if (!table) return;

    if (table.parent?.fieldName) {
      const { findRecord } = useStore.getState();
      const { store } = findRecord(
        table.parent.layout.model,
        table.parent.record.id,
      );
      const valuesStore = store[table.parent.fieldName];
      updateRowData(valuesStore, record);
    }

    table.records = table.records.map((rec) =>
      rec.id === record.id ? record : rec,
    );
  },
  deleteRow: async (key, record) => {
    // quizas aca debemos antes de eliminar, crear una modal con una alerta
    console.log("deleteRow", key, record);

    const table = get().getTable(key);
    if (!table) return;
    if (record?.id > 0) {
      await deleteRecord(table.layout.model, record.id);
      console.log("✅ Registro eliminado correctamente");
      return false;
    }

    // 🔹 if have parent
    if (table.parent?.fieldName) {
      const { findRecord } = useStore.getState();
      const { store } = findRecord(
        table.parent.layout.model,
        table.parent.record.id,
      );

      // Obtenemos el store del campo
      const valuesStore = store[table.parent.fieldName];
      const isExisting = record.id > 0;

      // 🔹 Si el registro es nuevo (no guardado aún)
      if (!isExisting) {
        // se elimina del Map "create"
        valuesStore.get("create")?.delete(record.id);
      } else {
        // 🔹 Si el registro ya existe, lo marcamos para eliminación
        const deleteList = valuesStore.get("delete") ?? [];
        // Evitamos duplicados
        if (!deleteList.includes(record.id)) deleteList.push(record.id);
        valuesStore.set("delete", deleteList);

        // también removemos de "write" o "create" si estaba ahí
        valuesStore.get("write")?.delete(record.id);
        valuesStore.get("create")?.delete(record.id);
      }

      // Actualizamos el store del formulario padre
      store[table.parent.fieldName] = valuesStore;
    }
    table.records = table.records.filter((rec) => rec.id !== record.id);
    const _store = get().store;
    _store.set(key, table);
    set((state) => ({
      store: new Map([...state.store, ..._store]),
    }));
    console.log("✅ Registro eliminado correctamente");
  },
  modalTable: {
    open: false,
    record: null,
    Component: null,
    title: null,
  },
  openModalTable: (Component, props = {}, title = "") => {
    set({
      modalTable: {
        Component,
        props, // 👈 guardamos todas las props aquí
        title,
        open: true,
      },
    });
  },
  closeModalTable: () => {
    set(() => ({
      modalTable: {
        open: false,
        record: null,
        Component: null,
        title: null,
      },
    }));
  },
  presetTable: async (storeId, layout, parentRec, modelChild) => {
    let records_ = [];
    const { findRecords } = get();
    const domainCtx = defaultDomain(layout);

    if (parentRec) {
      const fieldNameWithDot = `${parentRec.fieldName}.`;
      let recordsMap = parentRec.record[fieldNameWithDot];
      if (!recordsMap) {
        recordsMap = parentRec.record[parentRec.fieldName];
      }
      if (recordsMap) {
        if (recordsMap?.value) {
          records_ = Array.from(recordsMap?.value.values());
        } else if (Array.isArray(recordsMap)) {
          records_ = recordsMap;
        }
      }
    }
    const table = {
      storeId: storeId,
      layout: layout,
      records: records_,
      domain: domainCtx,
      offset: 0,
      count: 0,
      queried: false,
      create: new Map(),
      write: new Map(),
      delete: [],
      selected: new Map(),
      parent: parentRec,
    };
    if (domainCtx.default) {
      records_ = await findRecords(table, domainCtx);
      table.records = records_;
      table.count = await fetchCount(table.layout, buildDomain(domainCtx));
      table.queried = true;
    }

    if (modelChild) {
      table.model = modelChild;
    }

    // table.originalRecords = [...records_];
    const newTable = {};
    newTable[storeId] = table;
    set((state) => ({ ...state, ...newTable }));
    return table;
  },
  getRecords: async (storeId, layout, parentRec, domain) => {
    const { presetTable, findRecords, updateTable } = get();
    const table = presetTable(storeId, layout, parentRec);
    let records = [];
    if (parentRec) {
      const fieldNameWithDot = parentRec.fieldName + ".";
      let targets = parentRec.record[fieldNameWithDot];
      if (!targets) {
        targets = parentRec.record[parentRec.fieldName];
      }
      if (targets) {
        if (targets?.value) {
          records = Array.from(targets?.value.values());
        } else if (Array.isArray(targets)) {
          records = targets;
        }
      }
    } else {
      console.log("Buscando getRecords...", domain);
      records = await findRecords(table, domain);
    }
    await updateTable(table, records);
    console.log("table records.........", records);
    return records;
  },
}));

export { useTable };
